import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, isAxiosError } from "axios";
import api from "src/http/index";
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

import { RepairRequest, InsertRepair, RepairRequestLength } from "../../types/request.type";






export const repairsData = createAsyncThunk<RepairRequest[], void>(
  "/repairsData",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    try {
      const response = await api.get(`/repair-requests`, {
        params: {
          page: 1,
          qtyPerPage: 1000,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);






export const repairsDataPage = createAsyncThunk<RepairRequestLength, {}>(
  "/repairsDataPage",
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    try {

      var page = Number(Object.values(obj)[0]) + 1;
      var qtyPerPage = Number(Object.values(obj)[1]);

      const response = await api.get(`/repair-requests`, {
        params: {
          page: page,
          qtyPerPage: qtyPerPage,
        },

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);










export const repairsDataPost = createAsyncThunk<RepairRequest, InsertRepair>(
  "/repairsDataPost",
  async (new_repair, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const response = await api.post(
        `/repair-requests`,
        {
          request_date: new_repair.request_date,
          request_type_id: new_repair.request_type_id,
          num: new_repair.num,
          client_id: new_repair.client_id,
          client_contact_ids: new_repair.client_contact_ids,
          external_num: new_repair.external_num,
          wagon_type_id: new_repair.wagon_type_id,
          wagon_number: new_repair.wagon_number,
          staff_wagon_number: new_repair.staff_wagon_number,
          wagon_build_date: new_repair.wagon_build_date,
          route_number: new_repair.route_number,
          route: new_repair.route,
          appearance: {
            time_arrival: new_repair.appearance.time_arrival,
            time_departure: new_repair.appearance.time_departure,
            station: new_repair.appearance.station,
          },
          problems: new_repair.problems,
          complete_date: new_repair.complete_date,
          result: {
            done: new_repair.result.done,
            problems: new_repair.result.problems,
            description: new_repair.result.description,
          },
          executor: new_repair.executor,
          wagon_contact_ids: new_repair.wagon_contacts_ids,
        },
        config
      );

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const repairsDataID = createAsyncThunk<RepairRequest, number>(
  "/repairsDataID",
  async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await api.get(`/repair-requests/${id}`, {
        params: {
          page: 1,
          qtyPerPage: 10,
        },
      });

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const repairsDataUpdate = createAsyncThunk<RepairRequest, InsertRepair>(
  "/repairsDataUpdate",
  async (update_repair, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      //     const response = await api.patch(`${backendURL}/repair-requests/${repair.id}`, databody, config);

      const response = await api.patch(
        `/repair-requests/${update_repair.id}`,
        {
          request_date: update_repair.request_date,
          request_type_id: update_repair.request_type_id,
          num: update_repair.num,
          client_id: update_repair.client_id,
          client_contact_ids: update_repair.client_contact_ids,
          external_num: update_repair.external_num,
          wagon_type_id: update_repair.wagon_type_id,
          wagon_number: update_repair.wagon_number,
          staff_wagon_number: update_repair.staff_wagon_number,
          wagon_build_date: update_repair.wagon_build_date,
          route_number: update_repair.route_number,
          route: update_repair.route,
          appearance: {
            time_arrival: update_repair.appearance.time_arrival,
            time_departure: update_repair.appearance.time_departure,
            station: update_repair.appearance.station,
          },
          problems: update_repair.problems,
          complete_date: update_repair.complete_date,
          result: {
            done: update_repair.result.done,
            problems: update_repair.result.problems,
            description: update_repair.result.description,
          },
          executor: update_repair.executor,
          wagon_contact_ids: update_repair.wagon_contacts_ids,
        },
        config
      );

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const repairsDataDelete = createAsyncThunk<
  SuccessResponse,
  RepairRequest
>(
  "/repairsDataDelete",
  async (repair, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const { data } = await api.delete(
        `/repair-requests/${repair.id}`,
        config
      );

      return data;
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);

export const repairsDataDeleteByID = createAsyncThunk<SuccessResponse, number>(
  "/repairsDataDeleteByID",
  async (repairID, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const { data } = await api.delete(`/repair-requests/${repairID}`, config);

      return data;
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);
